import ExpertProfileSkillsAndExpertiseModule from './expert-profile-skills-and-expertise.module'

export default ExpertProfileSkillsAndExpertiseModule
